import { styled as a } from "@mui/material";
import s from "../../../hooks/generic/useCSR.js";
import i from "react-player";
import { jsx as o, Fragment as m } from "react/jsx-runtime";
const p = a(i)`
  aspect-ratio: 16 / 9;
`, y = (r) => {
  const {
    autoplay: t = !1,
    url: e
  } = r;
  return s() ? /* @__PURE__ */ o(p, {
    muted: t,
    playing: t,
    url: e,
    width: "100%",
    height: "100%"
  }) : /* @__PURE__ */ o(m, {});
};
export {
  y as default
};
//# sourceMappingURL=ApeironReactPlayer.js.map
